export class JSONDecryptor {
    private secretKey: Uint8Array;

    constructor(secretKey: string) {
        const enc = new TextEncoder();
        this.secretKey = enc.encode(secretKey.padEnd(32, '0').substring(0, 32)); // Ensure 32 bytes
    }

    async decrypt<T>(encryptedData: { iv: string; content: string }): Promise<T> {
        const iv = this.hexToBuffer(encryptedData.iv);
        const content = this.hexToBuffer(encryptedData.content);

        const cryptoKey = await window.crypto.subtle.importKey(
            'raw',
            this.secretKey,
            'AES-CBC',
            false,
            ['decrypt']
        );

        const decrypted = await window.crypto.subtle.decrypt(
            {
                name: 'AES-CBC',
                iv: iv
            },
            cryptoKey,
            content
        );
       // await window.crypto.subtle.encrypt(algorith,cryptoKey,content)

        const dec = new TextDecoder();
        return JSON.parse(dec.decode(decrypted));
    }

    private hexToBuffer(hex: string): Uint8Array {
        return Uint8Array.from(hex.match(/.{1,2}/g)!.map(byte => parseInt(byte, 16)));
    }

    //Encrypt data
    async encrypt<T>(data: T): Promise<EncryptedData> {
        const iv = window.crypto.getRandomValues(new Uint8Array(16));
        const enc = new TextEncoder();
        const content = enc.encode(JSON.stringify(data));

        const cryptoKey = await window.crypto.subtle.importKey(
            'raw',
            this.secretKey,
            'AES-CBC',
            false,
            ['encrypt']
        );

        const encrypted = await window.crypto.subtle.encrypt(
            {
                name: 'AES-CBC',
                iv: iv
            },
            cryptoKey,
            content
        );

        const hex = Array.from(new Uint8Array(encrypted))
            .map(byte => byte.toString(16).padStart(2, '0'))
            .join('');

        return {
            iv: Array.from(iv)
                .map(byte => byte.toString(16).padStart(2, '0'))
                .join(''),
            content: hex
        };
    }
}
export interface EncryptedData {
    iv: string;
    content: string;
}
